import React from 'react';
export const AnalyticsListContext = /*#__PURE__*/React.createContext({
  list: '',
  positions: {}
});
export const AnalyticsListProvider = AnalyticsListContext.Provider;